import useEncryptedURLState from 'hooks/useEncryptedURLState';

export default function useHandleFilterChange(defaultFilter = {}) {
  const [fileManagerFilters, setFileManagerFilters] = useEncryptedURLState('filter', defaultFilter);

  function onFilterChange(e, clearBreadcrumbs = () => {}) {
    if (!e?.value?.id || !e?.value) {
      clearBreadcrumbs();
    }
    setFileManagerFilters((prevValues) => ({
      ...prevValues,
      [e?.target?.name]: e?.target?.value || e?.value,
      // Handle shared_folder flag inheritance for folder navigation
      // If shared_folder is explicitly set to false (bypass for shared folders), use that
      // Otherwise, handle normal inheritance logic
      ...(e?.shared_folder !== undefined
        ? { shared_folder: e.shared_folder }
        : e?.target?.name === 'selectedFolder' && prevValues.shared_folder
        ? { shared_folder: prevValues.shared_folder }
        : {}),
      // Handle shared_contact_list (clear from filters if null)
      ...(e.hasOwnProperty('shared_contact_list')
        ? e.shared_contact_list !== null
          ? { shared_contact_list: e.shared_contact_list }
          : { shared_contact_list: undefined }
        : {}),
      // Handle folder_shared (clear from filters if null)
      ...(e.hasOwnProperty('folder_shared')
        ? e.folder_shared !== null
          ? { folder_shared: e.folder_shared }
          : { folder_shared: undefined }
        : {}),
    }));
  }
  function onTagChange(e) {
    setFileManagerFilters((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.value,
    }));
  }

  return { fileManagerFilters, onFilterChange, onTagChange, setFileManagerFilters };
}
